import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import StatementCard from "./StatementCard"
import StepHeading from "./StepHeading"

const AUTO_ADVANCE_DELAY_MS = 350

type Answer = "no" | "yes"

interface Props {
  id: string
  onAnswer: (answers: string[]) => void
}

export default function StatementStep({ id, onAnswer }: Props) {
  const [selected, setSelected] = useState<Answer>()
  const { t } = useTranslation()

  const handleSelect = (answer: Answer) => {
    if (selected) return

    setSelected(answer)
    setTimeout(() => onAnswer([answer]), AUTO_ADVANCE_DELAY_MS)
  }

  const buttonClass = (answer: Answer) =>
    `vm-option animate-fade-up flex-col justify-center gap-2 py-6 text-center ${
      selected === answer ? "vm-option-selected" : ""
    }`

  return (
    <div className="flex grow flex-col gap-6 pt-4">
      <StepHeading headingKey="pages.onboarding.statementHeading" />

      <div className="flex grow flex-col justify-center">
        <StatementCard text={t(`pages.onboarding.steps.${id}.statement`)} />
      </div>

      <div className="grid grid-cols-2 gap-3 pb-6">
        <button
          className={buttonClass("no")}
          onClick={() => handleSelect("no")}
          style={{ animationDelay: "250ms" }}
          type="button"
        >
          <XMarkIcon className="h-8 w-8 text-vm-red" strokeWidth={2.5} />
          {t("pages.onboarding.no")}
        </button>

        <button
          className={buttonClass("yes")}
          onClick={() => handleSelect("yes")}
          style={{ animationDelay: "310ms" }}
          type="button"
        >
          <CheckIcon className="h-8 w-8 text-vm-green" strokeWidth={2.5} />
          {t("pages.onboarding.yes")}
        </button>
      </div>
    </div>
  )
}
